import countries from 'i18n-iso-countries';
import Location from 'models/Location';
import moment from 'moment';
import { TopDestination } from 'store/types';

export const getFullLocationName = (location: Location | null, language: string) =>
  location
    ? [location?.name, countries.getName(location.countryCode, language.substring(0, 2))].filter(Boolean).join(' - ')
    : '';

export const groupLocations = (list: Location[], keyGetter: (location: Location) => string) => {
  const map = new Map();

  list.forEach((item: Location) => {
    const key = keyGetter(item);
    const collection = map.get(key);

    map.set(key, [...(collection ?? []), item]);
  });

  return map;
};

export const normalizeAccents = (country: string | null): string =>
  country ? country.normalize('NFD').replace(/[\u0300-\u036f]/g, '') : '';

const departureDate2 = moment().toISOString();

export const getSearch = ({ idLocalityOrigin, idLocalityDestination }: TopDestination) =>
  `departureLocation=${idLocalityOrigin}&arrivalLocation=${idLocalityDestination}&departDate=${departureDate2}`;

// Constants for Madrid and Porto location IDs
const MADRID_LOCATION_ID = 52641;
const MADRID_LOCATION_ID_2 = 52645;
const PORTO_LOCATION_ID = 52591;
const PORTO_LOCATION_ID_2 = 10010;

/**
 * Verifica se uma viagem é entre Madrid e Porto (em qualquer direção)
 * @param departure Local de partida (objeto com id/externalId ou número)
 * @param arrival Local de chegada (objeto com id/externalId ou número)
 * @returns true se a viagem é entre Madrid e Porto, false caso contrário
 */
export const isMadridPortoRoute = (departure: any, arrival: any): boolean => {
  const departureId = departure?.id;
  const arrivalId = arrival?.id;

  if (!departureId || !arrivalId) return false;

  return (
    ((departureId === MADRID_LOCATION_ID || departureId === MADRID_LOCATION_ID_2) &&
      (arrivalId === PORTO_LOCATION_ID || arrivalId === PORTO_LOCATION_ID_2)) ||
    ((departureId === PORTO_LOCATION_ID || departureId === PORTO_LOCATION_ID_2) &&
      (arrivalId === MADRID_LOCATION_ID || arrivalId === MADRID_LOCATION_ID_2))
  );
};
